/*
 * @Author: Gaho
 * @Date: 2024-03-14 16:26:02
 * @LastEditors: Gaho
 * @LastEditTime: 2024-09-09 15:13:51
 * @Description: 
 */
import { accMultiple } from "../js/module.js";
/**
 * 赢分
 */
export const winAmount = (amount, mutil?) =>{
    const win = typeof mutil !== 'undefined' ? accMultiple(amount, mutil).toString() : String(amount);
    if (win.length <= 10){
        return win;
    } 
    if (win.length > 10){ // 最大长度为10，超过10则截取前十位
        return win.slice(0, 10);
    }
}
/**
 * 为赢分补0
 * @param {number} amount 下注金额
 * @param {number} mutil 当前倍率
 */
export const setAmountZero = (amount, mutil?) => {
    const win = winAmount(amount, mutil);
    let zeroLength = 0;
    let amountZero = '';
    if (win.length < 10){
        if (win.indexOf('.') > -1) {
            zeroLength = 10 - win.length;
            amountZero = new Array(zeroLength).fill('0').join('');
        } else {
            zeroLength = 10 - win.length - 1;
            amountZero = '.' + new Array(zeroLength).fill('0').join('');
        }
    }
    return amountZero;
}